"use client";

export default function GlobalError({
  error,
  reset,
}: {
  readonly error: Error & { readonly digest?: string };
  readonly reset: () => void;
}) {
  return (
    <html lang="en">
      <body>
        <h2>Something went wrong!</h2>
        {JSON.stringify(error)}
        <button onClick={() => reset()}>Try again</button>
      </body>
    </html>
  );
}
